import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b5775d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "PretensionFormFiles"
}
const _hoisted_2 = { class: "PretensionFormFiles__title" }
const _hoisted_3 = { class: "PretensionFormFiles__holder" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "file__pdf"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download mr-2" }, null, -1))
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (Boolean(_ctx.files.length))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.files, (file, idx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "PretensionFormFiles__file",
              key: `img-${idx}`,
              onClick: ($event: any) => (_ctx.downloadPretension(file.url || file.path))
            }, [
              (_ctx.isPDF(file.url || file.path))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _hoisted_6,
                    _createTextVNode("Скачать PDF-" + _toDisplayString(idx), 1)
                  ]))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: file.url || file.path,
                    alt: "image",
                    class: "file__img"
                  }, null, 8, _hoisted_7))
            ], 8, _hoisted_4))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}